<template>
  <b-row>
    <template v-if="maintenanceDetailData.trigger === 'CALENDAR'">
      <b-col cols="6">
        <b-form-group label="Due Maintenance Date">
          <date-picker
            style="width: 100%"
            v-model="localForm.possibleMaintenanceDate"
            value-type="DD-MM-YYYY"
            format="DD MMM YYYY"
            type="date"
            disabled
            placeholder="Select date"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Maintenance Date *">
          <date-picker
            style="width: 100%"
            v-model="localForm.maintenanceDate"
            value-type="DD-MM-YYYY"
            format="DD MMM YYYY"
            type="date"
            placeholder="Select date"
          ></date-picker>
        </b-form-group>
      </b-col>
    </template>
    <template v-else>
      <b-col cols="12">
        <b-form-group label="Maintenance Date *">
          <date-picker
            style="width: 100%"
            v-model="localForm.maintenanceDate"
            value-type="DD-MM-YYYY"
            format="DD MMM YYYY"
            type="date"
            placeholder="Select date"
          ></date-picker>
        </b-form-group>
      </b-col>
    </template>
    <template v-if="maintenanceDetailData.trigger === 'COUNTER'">
      <b-col cols="6">
        <b-form-group label="Due Maintenance Hours">
          <b-input-group>
            <b-form-input disabled placeholder="0" type="number"></b-form-input>
            <b-input-group-append>
              <b-input-group-text>Hours</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group label="Maintenance Hours *">
          <b-input-group>
            <b-form-input
              placeholder="0"
              type="number"
              v-model="localForm.maintenanceRunningHours"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text>Hours</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </template>
    <b-col cols="12">
      <b-form-group label="Cost">
        <InputCurrency v-model="localForm.cost" placeholder="0" />
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group label="File Maintenance">
        <b-form-file
          placeholder="Choose a file"
          name="select-file-maintenance"
          @change="($event) => $emit('uploadFile', $event)"
        ></b-form-file>
        <small class="text-muted">
          File Type * :
          <b-badge variant="warning"
            >.jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf</b-badge
          ><br />
          File Capacity * :
          <b-badge variant="warning">2 MB / File</b-badge>
        </small>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group label="Notes *">
        <wysiwyg v-model="localForm.notes" />
        <small>Sign * : <strong>Mandatory (Must Fill)</strong></small>
      </b-form-group>
    </b-col>
    <b-col md="6" class="text-center">
      <button
        type="button"
        @click="onAction('VIEW_DETAIL')"
        class="btn btn-outline-primary w-100"
        >Cancel</button
      >
    </b-col>
    <b-col md="6" class="text-center">
      <button
        type="button"
        class="btn btn-primary w-100"
        @click="$emit('submitForm')"
        >Submit</button
      >
    </b-col>
  </b-row>
</template>

<script>
import InputCurrency from '@/src/components/global/InputCurrency.vue'
import { numberFormat } from '@/src/plugins/helpers'

export default {
  name: 'OnMaintenanceForm',
  components: {
    InputCurrency,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    maintenanceDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    numberFormat,
  },
  computed: {
    localForm: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>
